// src/dialog/src/dialog-elements/DialogActions.tsx
import { jsx } from "react/jsx-runtime";
var DialogActions = ({
  children,
  ...rest
}) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  /* @__PURE__ */ jsx("div", { className: "mt-8 flex flex-col gap-4 sm:flex-row-reverse", ...rest, children })
);

export {
  DialogActions
};
